import { GridApi, IRowNode } from 'ag-grid-community';
import { useMutation } from '@apollo/client';
import {
	alephToast, NotificationToast, NotificationType,
} from '@aleph/shared-components';
import { captureException } from '@sentry/react';
import { CampaignStatus, ChangeStatusOfEntitiesDocument } from 'wb-spotify/graphql/generated';
import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';

// For now only allow status change for campaigns, what happens on the other level is still in discussion
// See this slack thread https://alephholding.slack.com/archives/C046JEDA003/p1754311924794009
const useChangeStatusBulkAction = (gridApi: GridApi | null) => {
	const [doStatusChange, { loading }] = useMutation(ChangeStatusOfEntitiesDocument);

	const onChangeStatus = async (rowNodes: IRowNode[]) => {
		const isPause = rowNodes.every(rowNode => rowNode.data.status === CampaignStatus.Active);
		const isResume = rowNodes.every(
			rowNode => [CampaignStatus.Paused, CampaignStatus.Archived].includes(rowNode.data.status),
		);

		if (!isPause && !isResume) {
			return;
		}

		const status = isPause ? CampaignStatus.Paused : CampaignStatus.Active;

		try {
			await doStatusChange({
				variables: {
					// ads: rowNodes.filter(
					// 	rowNode => rowNode.data.level === RedditLevel.AD,
					// ).map(rowNode => ({
					// 	adHash:   rowNode.data.id,
					// 	adId:     rowNode.data.id,
					// 	adStatus: status as unknown as CreateAdStatus,
					// })),
					// groups: rowNodes.filter(
					// 	rowNode => rowNode.data.level === RedditLevel.GROUP,
					// ).map(rowNode => ({
					// 	groupHash:   rowNode.data.id,
					// 	groupId:     rowNode.data.id,
					// 	groupStatus: status as unknown as CreateGroupStatus,
					// })),
					campaigns: rowNodes.filter(
						rowNode => rowNode.data.level === SpotifyLevel.CAMPAIGN,
					).map(rowNode => ({
						campaignHash:   rowNode.data.id,
						campaignId:     rowNode.data.id,
						campaignStatus: status as unknown as CampaignStatus,
					})),
				},
			});

			rowNodes.forEach(rowNode => {
				gridApi?.applyServerSideTransaction({
					route:  rowNode.getRoute()?.slice(0, -1),
					update: [{
						...rowNode.data,
						status,
					}],
				});
			});

			alephToast(
				<NotificationToast
					type={NotificationType.Success}
					title={
						<div>
							Successfully staged the change of status for
							&nbsp;
							<strong>{rowNodes.length}</strong>
							&nbsp;
							entities to <strong>{status.toLowerCase()}</strong>.
						</div>
					}
				/>,
			);
		} catch (e) {
			captureException(e);
			alephToast(
				<NotificationToast
					type={NotificationType.Error}
					title="Changing status of entities failed. We have been notified."
				/>,
			);
		}
	};

	return {
		onChangeStatus,
		loading,
	};
};

export default useChangeStatusBulkAction;
